<template>
    <div class="text-xs-center mt-2">
        <h1 :class="(rating<7?'red':'green')+'--text'"><span v-model="rating">{{ rating }}</span><span class="headline">&nbsp;คะแนน</span></h1>
        <v-rating v-model="rating" color="yellow darken-3" length="10" medium light dense hover empty-icon="$vuetify.icons.ratingFull" background-color="grey lighten-1"></v-rating>
        <div class="align-self-center caption">น้อยสุด<span class="grey--text text--lighten-1 ">-------------------------------------------------------></span>มากสุด</div>
    </div>
</template>

<script>
    export default {
        name: "RatingStar",
        props:{
            question_id:String
        },
        watch:{
            rating(){
                this.setScore()
            }
        },
        data(){
            return{
                rating:0
            }
        },
        methods:{
            setScore(){
                this.$emit('set_score', {question_id:this.question_id,score:this.rating})
            }
        }
    }
</script>

<style scoped>

</style>